import React, { useEffect, useState } from "react";

const Card = () => {
  let [likes, setLike] = useState(200);
  let [likeStat, setLikeStat] = useState(false);

  let [bigLikeIcon, setBigLikeIcon] = useState(false);

 

  const likeHandler = () => {
    setLikeStat((likeStat = !likeStat));


    setBigLikeIcon(false);
    if (likeStat === true) {
      setLike(likes + 1);
    } else {
      setLike(likes - 1);
    }
  };

  return (
    <div className="container-feed-posts-post">
      <div className={`post-like ${likeStat ? "post-like-active" : "post-like-inactive"} `}>
        <svg
          className="likeAnimation"
          xmlns="http://www.w3.org/2000/svg"
          width="131"
          height="131"
          fill="none"
          viewBox="0 0 131 131"
        >
          <g clip-path="url(#a)">
            <path
              fill="#ea4d88"
              stroke="#ffadcc"
              strokeWidth="1"
              fill-opacity=".9"
              d="M65.5 122.149a3.832 3.832 0 0 1-1.919-.514c-.644-.372-15.963-9.266-31.501-22.668-9.21-7.942-16.561-15.82-21.85-23.414C3.387 65.726-.055 56.274 0 47.459c.066-10.257 3.74-19.904 10.346-27.162C17.065 12.916 26.03 8.85 35.593 8.85c12.254 0 23.459 6.865 29.907 17.74C71.95 15.715 83.153 8.85 95.408 8.85c9.034 0 17.653 3.668 24.27 10.327 7.263 7.308 11.389 17.634 11.321 28.33-.055 8.8-3.561 18.237-10.42 28.05-5.305 7.59-12.646 15.465-21.82 23.405-15.481 13.4-30.69 22.294-31.33 22.666a3.844 3.844 0 0 1-1.929.52Z"
            />
          </g>
          <defs>
            <clipPath id="a">
              <path fill="#ea4d88" d="M0 0h131v131H0z" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div className="post-header">
        <div className="post-header-info">
          <img alt="feed profile id" src="./images/dummyFeedProfile1.png" />
          <div className="post-title">
            <h3>Xettri Aleen</h3>
            <p>A beautiful Morning view from.....</p>
          </div>
        </div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21"
          height="19"
          fill="none"
          viewBox="0 0 21 19"
        >
          <circle cx="2.523" cy="2.523" r="2.523" fill="#fff" />
          <circle cx="17.659" cy="2.523" r="2.523" fill="#fff" />
          <circle cx="2.523" cy="15.977" r="2.523" fill="#fff" />
          <circle cx="17.659" cy="15.977" r="2.523" fill="#fff" />
        </svg>
      </div>
      <div className="post-body">
        <img src="./images/dummyyFeed1.png" alt="" />
      </div>
      <div className="post-footer">
        <div className="post-footer-interact">
          <div
            className={`items likes  ${likeStat === true ? "activeLike" : ""}`}
            onClick={likeHandler}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24"
              className="LikeFillMain"
            >
              <path
                stroke="#FBFBFB"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="M11.748 20.854a36.495 36.495 0 0 1-6.338-4.689 11.923 11.923 0 0 1-3.017-4.57c-1.133-3.345.19-7.174 3.892-8.307a6.563 6.563 0 0 1 5.71.913 6.573 6.573 0 0 1 5.711-.913c3.703 1.133 5.035 4.962 3.903 8.307a11.924 11.924 0 0 1-3.018 4.57 36.495 36.495 0 0 1-6.338 4.689l-.248.146-.257-.146Z"
                clip-rule="evenodd"
                className="LikeFillChild"
              />
              <path
                stroke="#FBFBFB"
                className="LikeFillChildSemi"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M15.936 7.053c1.122.34 1.918 1.297 2.018 2.422"
                opacity=".4"
              />
            </svg>
            <div className="like">{likes}</div>
          </div>
          <div className="items">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke="#FBFBFB"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="M12.057 2A10.02 10.02 0 0 0 3.46 6.8a9.986 9.986 0 0 0-.322 9.829l.2.39c.164.307.198.668.095 1-.286.76-.525 1.536-.715 2.324 0 .4.114.629.544.619.76-.168 1.509-.384 2.241-.648a1.48 1.48 0 0 1 .954.058c.277.133.84.476.859.476a10.03 10.03 0 0 0 11.284-1.34 9.99 9.99 0 0 0 2.768-11.004A10.016 10.016 0 0 0 12.057 2v0Z"
                clip-rule="evenodd"
              />
              <ellipse
                cx="7.287"
                cy="12"
                fill="#FBFBFB"
                stroke="#FBFBFB"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                opacity=".4"
                rx=".477"
                ry=".476"
              />
              <ellipse
                cx="12.057"
                cy="12"
                fill="#FBFBFB"
                stroke="#FBFBFB"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                opacity=".4"
                rx=".477"
                ry=".476"
              />
              <ellipse
                cx="16.826"
                cy="12"
                fill="#FBFBFB"
                stroke="#FBFBFB"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                opacity=".4"
                rx=".477"
                ry=".476"
              />
            </svg>

            <div className="comment">30</div>
          </div>
          <div className="items">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke="#FBFBFB"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="M11.665 18.632 5.733 21.88a.989.989 0 0 1-1.318-.394v0a1.043 1.043 0 0 1-.119-.466V6.622c0-2.746 1.877-3.844 4.577-3.844h6.343c2.618 0 4.577 1.025 4.577 3.661v14.582a.98.98 0 0 1-.98.979 1.079 1.079 0 0 1-.475-.119l-5.968-3.25a.741.741 0 0 0-.705 0Z"
                clip-rule="evenodd"
              />
              <path
                stroke="#FBFBFB"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="M8.37 9.323h7.295"
                opacity=".4"
              />
            </svg>

            <div className="save">2</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
